<template>
  <div class="footer position-relative">
<!--    <img src="../assets/home/bg_gray.png" alt="">-->
    <div class="footer-container">
      <div class="footer-top">
        <div class="top">
          <div class="top-right">
            <div class="icon-right">
              <img src="../assets/home/footer-logo.png" alt="">
            </div>
          </div>
          <div class="top-left" style="width: 65%;flex: 1">
            <div class="left-title">
              <div v-for="item in tabs" :key="item.id" @click="onChange(item)">{{item.title}}</div>
            </div>
            <div class="short-line"></div>
            <div class="contact">
                <div class="phone">Mobile：+86 <span>13559269988</span></div>
                <div class="email">E-mail：Vinzheng0929@gmail.com</div>
                <div class="address" v-if="$i18n.locale == 'zh'">中国：深圳市龙岗区坂田生态科技园C栋3楼305</div>
                <div class="address" v-else>China：3F 305, Building C, Bantian Ecological Science and Technology Park, Longgang District, Shenzhen</div>
            </div>
            <div class="contact">
              <div class="phone">Mobile：<span> +60 </span><span> 136229988</span></div>
              <div class="email">E-mail：Vinzheng0929@gmail.com</div>
              <div class="address">Kuala Lumpur：Level 13A-01,02,03 Vertical Business Suite ll,Tower B,Bangsar South,59200 Kuala Lumpur</div>
            </div>
          </div>
        </div>
      </div>
      <div class="long-line"></div>
      <div class="icp">
        <div>{{$t('footer.internet')}}</div>
        <div class="weixin">
          <img src="../assets/home/weixin.png" alt="">
        </div>
      </div>
      <div class="user-icon">
        <img src="../assets/home/user.png" alt="">
        <img class="toTop" @click="topTop" src="../assets/home/totop.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import router from "@/router";

export default {
  data() {
    return {

    }
  },
  computed: {
    tabs() {
      return [
        {id: 0, url: '/home', title: this.$t('header.page1')},
        {id: 1, url: '/witstar', title: this.$t('header.page2')},
        {id: 3, url: '/brandOverseas', title: this.$t('header.page6')},
        {id: 4, url: '/success', title: this.$t('header.page3')},
        {id: 5, url: '/serve', title: this.$t('header.page4')},
        {id: 6, url: '/contact', title: this.$t('header.page5')},
      ]
    }
  },
  methods: {
    onChange(item) {
      if (this.tabIndex == item.id) return
      this.$store.commit('setTabIndex', item.id)
      router.push(item.url)
    },
    topTop() {
      document.documentElement.scrollTop = 0
    }
  }
}
</script>
<style lang="scss" scoped>
.footer-container {
  width: 100%;
  z-index: 11;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: #2E3239;
  .footer-top {
    width: 90%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .top {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 142px;
      .top-right {
        width: 40%;
        display: flex;
        justify-content: center;
        .icon-right {
          width: 364px;
          height: 126px;
        }
      }
      .top-left {
        flex: 1;
        width: 100%;
        .left-title {
          display: flex;
          align-items: center;
          font-weight: bold;
          justify-content: space-between;
          height: 124px;
          div:hover {
            cursor: pointer;
          }
        }
        .short-line {
          height: 1px;
          width: 100%;
          background: #97999C;
          margin-top: 10px;
        }
        .contact {
          display: flex;
          flex-direction: column;
          text-align: start;
          .phone {
            margin-top: 40px;
          }
          .email {
            margin-top: 26px;
          }
          .address {
            margin-top: 26px;
          }
        }
      }
    }
  }
  .long-line {
    height: 1px;
    width: 90%;
    margin: 40px auto 0px auto;
    background: #97999C;
  }
  .icp {
    width: 90%;
    margin: 0 auto;
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .weixin {
      width: 34px;
      height: 34px;
    }
  }
  .user-icon {
    position: absolute;
    width: 67px;
    height: 158px;
    right: 23px;
    bottom: 152px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    img {
      width: 50px;
      height: 50px;
    }
    .toTop {
      cursor: pointer;
    }
  }
}
</style>
